import {
  Directive,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Store } from '@ngxs/store';
import { FocusInput, InputLosesFocus } from 'src/app/store/app/app.action';
import { APP_STATE_TOKEN } from 'src/app/store/app/app.state.model';

const selector = 'ion-input, ion-textarea, ion-searchbar, input, ng-select';

@Directive({ selector })
export class InputFocusDirective implements OnDestroy, OnInit {
  private readonly onIonFocus = () => this.focusInput();
  private readonly onIonBlur = () => this.inputLosesFocus();

  constructor(
    private readonly store: Store,
    private readonly elementRef: ElementRef<
      HTMLIonInputElement | HTMLSelectElement
    >
  ) {}

  ngOnInit(): void {
    this.elementRef.nativeElement.addEventListener('ionFocus', this.onIonFocus);
    this.elementRef.nativeElement.addEventListener('ionBlur', this.onIonBlur);
  }

  private get isInputFocused(): boolean {
    return this.store.selectSnapshot(APP_STATE_TOKEN).isInputFocused;
  }

  private focusInput() {
    !this.isInputFocused && this.store.dispatch(new FocusInput());
  }

  private inputLosesFocus() {
    this.isInputFocused && this.store.dispatch(new InputLosesFocus());
  }

  @HostListener('focus')
  onFocus() {
    this.focusInput();
  }

  @HostListener('blur')
  onBlur() {
    this.inputLosesFocus();
  }

  ngOnDestroy(): void {
    const isFocused = this.elementRef.nativeElement === document.activeElement;
    if (isFocused) {
      this.inputLosesFocus();
    }
    this.elementRef.nativeElement.removeEventListener(
      'ionFocus',
      this.onIonFocus
    );
    this.elementRef.nativeElement.removeEventListener(
      'ionBlur',
      this.onIonBlur
    );
  }
}
